module.exports = __webpack_public_path__ + "static/media/crew-m-2.37e406e4.png";